import { UserGivenProductionType } from './user-given-production-type';
import { ProductionType } from '../../../../../services/analysis.service';

export class NrelProductionType extends UserGivenProductionType {
  getProductionType(): ProductionType {
    return ProductionType.NREL;
  }

}
